/**
 * Form v2 — supForm runtime için rule evaluator.
 * FormModulePromt §3.3, §9.4, §9.5.
 * customer-panel/src/views/Pages/Forms/registry/conditionEvaluator.js ile aynı mantık.
 */

function isEmpty(v) {
    return v === null || v === undefined || v === "" || (Array.isArray(v) && v.length === 0);
}

// Skaler ya da dizi değeri, karşılaştırma için tekdüze diziye çevirir.
function toArray(v) {
    if (Array.isArray(v)) return v;
    if (v === null || v === undefined || v === "") return [];
    return [v];
}

// Kaynak değerin herhangi bir öğesi beklenen metni (alt dize) içeriyor mu?
// Hem string (tekli seçim) hem dizi (çoklu seçim) için çalışır.
function anyContains(sourceValue, expected) {
    var exp = String(expected == null ? "" : expected).toLowerCase();
    return toArray(sourceValue).some(function (item) {
        return String(item == null ? "" : item).toLowerCase().indexOf(exp) !== -1;
    });
}

// Kaynak değeri (dizi veya tekil) beklenen değeri barındırıyor mu? (üyelik)
function includesValue(sourceValue, expected) {
    return toArray(sourceValue).some(function (item) { return String(item) === String(expected); });
}

// "Eşittir": tekil değerde birebir eşitlik; dizi (çoklu seçim) değerinde ise SADECE
// beklenen değer tek başına seçiliyken (başka hiçbir şık seçili değilken) eşit sayılır.
// "Seçilenler arasında olsa yeter" davranışı için includes/contains kullanılır.
function equalsExact(sourceValue, expected) {
    if (Array.isArray(sourceValue)) {
        return sourceValue.length === 1 && String(sourceValue[0]) === String(expected);
    }
    return String(sourceValue) === String(expected);
}

// DropDownList değerini { selected, fieldLabel, altLabel } objesi olarak saklar;
// koşul karşılaştırması için içindeki "selected" değerine indirger.
function normalizeSourceValue(value) {
    if (value && typeof value === "object" && !Array.isArray(value) &&
        Object.prototype.hasOwnProperty.call(value, "selected")) {
        return value.selected;
    }
    return value;
}

export function compareOperator(operator, sourceValue, expected) {
    // Kaynak alan cevaplanmadıysa (boş) değer karşılaştıran hiçbir operatör sağlanmaz.
    // Böylece notEquals/notContains/notIncludes gibi olumsuz operatörler kullanıcı
    // seçim yapmadan koşulu tetiklemez. isEmpty/isNotEmpty bunun dışındadır.
    if (isEmpty(sourceValue) && operator !== "isEmpty" && operator !== "isNotEmpty") {
        return false;
    }
    switch (operator) {
        case "equals": return equalsExact(sourceValue, expected);
        case "notEquals": return !equalsExact(sourceValue, expected);
        case "contains": return anyContains(sourceValue, expected);
        // İçermez: seçilenlerin HİÇBİRİ beklenen metni içermemeli. Çoklu seçimde
        // beklenen değer seçilenler arasında varsa (birden fazla seçilse bile) koşul sağlanmaz.
        case "notContains": return !anyContains(sourceValue, expected);
        case "greaterThan": return Number(sourceValue) > Number(expected);
        case "lessThan": return Number(sourceValue) < Number(expected);
        case "isEmpty": return isEmpty(sourceValue);
        case "isNotEmpty": return !isEmpty(sourceValue);
        case "includes": return includesValue(sourceValue, expected);
        case "notIncludes": return !includesValue(sourceValue, expected);
        default: return false;
    }
}

function evaluateRule(rule, formValues) {
    if (!rule || !rule.sourceFieldId) return false;
    var sourceValue = normalizeSourceValue(formValues[String(rule.sourceFieldId)]);
    return compareOperator(rule.operator, sourceValue, rule.value);
}

function evaluateConditionGroup(group, formValues) {
    if (!group || !Array.isArray(group.rules) || group.rules.length === 0) return true;
    var results = group.rules.map(function (r) { return evaluateRule(r, formValues); });
    var passed = group.logic === "any" ? results.some(Boolean) : results.every(Boolean);
    if (group.when === "hide") return !passed;
    return passed;
}

export function evaluateFieldConditions(field, formValues) {
    if (!field || !Array.isArray(field.conditions) || field.conditions.length === 0) return true;
    return field.conditions.every(function (g) { return evaluateConditionGroup(g, formValues); });
}

export function evaluateBranchSection(field, formValues) {
    if (!field || field.type !== "branchSection" || !field.branchSection) return true;
    var bs = field.branchSection;
    if (!bs.sourceFieldId) return true;
    var sourceValue = normalizeSourceValue(formValues[String(bs.sourceFieldId)]);
    return compareOperator(bs.operator || "equals", sourceValue, bs.expectedValue);
}

export function evaluateConditions(formValues, fields) {
    var hiddenFieldIds = new Set();
    if (!Array.isArray(fields)) return { hiddenFieldIds: hiddenFieldIds };
    var values = formValues || {};

    fields.forEach(function (field) {
        if (!evaluateFieldConditions(field, values)) {
            hiddenFieldIds.add(String(field._id));
        }
    });

    fields.forEach(function (field) {
        if (field.type !== "branchSection") return;
        var visible = evaluateBranchSection(field, values);
        if (!visible) {
            hiddenFieldIds.add(String(field._id));
            if (field.branchSection && Array.isArray(field.branchSection.children)) {
                field.branchSection.children.forEach(function (cid) {
                    hiddenFieldIds.add(String(cid));
                });
            }
        }
    });

    fields.forEach(function (field) {
        if (field.parentBranchId && hiddenFieldIds.has(String(field.parentBranchId))) {
            hiddenFieldIds.add(String(field._id));
        }
    });

    return { hiddenFieldIds: hiddenFieldIds };
}

export default {
    evaluateConditions: evaluateConditions,
    evaluateFieldConditions: evaluateFieldConditions,
    evaluateBranchSection: evaluateBranchSection,
    compareOperator: compareOperator,
};
